import {
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  DELETE_BOOKING_REQUEST,
  DELETE_BOOKING_SUCCESS,
  DELETE_BOOKING_FAILURE,
  ADD_BOOKING_REQUEST,
  ADD_BOOKING_SUCCESS,
  ADD_BOOKING_FAILURE,
  FETCH_BOOKING_REQUEST,
  FETCH_BOOKING_SUCCESS,
  FETCH_BOOKING_FAILURE,
  FETCH_SERVICE_TYPE_REQUEST,
  FETCH_SERVICE_TYPE_SUCCESS,
  FETCH_SERVICE_TYPE_FAILURE,
  FETCH_ALL_BOOKINGS_REQUEST,
  FETCH_ALL_BOOKINGS_SUCCESS,
  FETCH_ALL_BOOKINGS_FAILURE,
  FETCH_CUSTOMER_BOOKINGS_REQUEST,
  FETCH_CUSTOMER_BOOKINGS_SUCCESS,
  FETCH_CUSTOMER_BOOKINGS_FAILURE,
  FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
  FETCH_TRANSIT_SERVICE_TYPE_SUCCESS,
  FETCH_TRANSIT_SERVICE_TYPE_FAILURE,
  FETCH_COMPLEMENTARY_BOOKINGS_FAILURE,
  FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS,
  FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_SUCCESS,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE,
  RESET_BOOKING_DETAILS,
  INSERT_INSTANT_BOOKING_REQUEST,
  INSERT_INSTANT_BOOKING_SUCCESS,
  INSERT_INSTANT_BOOKING_FAILURE,
  INSTANT_TOKEN_GENERATOR_REQUEST,
  INSTANT_TOKEN_GENERATOR_SUCCESS,
  INSTANT_TOKEN_GENERATOR_FAILURE,
  FETCH_INSTANT_BOOKINGS_REQUEST,
  FETCH_INSTANT_BOOKINGS_SUCCESS,
  FETCH_INSTANT_BOOKINGS_FAILURE,
  EDIT_BOOKING_REQUEST,
  EDIT_BOOKING_SUCCESS,
  EDIT_BOOKING_FAILURE,
  GET_ALL_BOOKINGS_REQUEST,
  GET_ALL_BOOKINGS_SUCCESS,
  GET_ALL_BOOKINGS_FAILURE,
  FETCH_ALL_BOOKING_REQUEST,
  FETCH_ALL_BOOKING_SUCCESS,
  FETCH_ALL_BOOKING_FAILURE,
  RAZORPAY_RESEND_LINK_REQUEST,
  RAZORPAY_RESEND_LINK_SUCCESS,
  RAZORPAY_RESEND_LINK_FAILURE,
  RAZORPAY_RESEND_LINK_RESET,
  UPDATE_PAYMENT_STATUS_REQUEST,
  UPDATE_PAYMENT_STATUS_SUCCESS,
  UPDATE_PAYMENT_STATUS_FAILURE,
  UPDATE_PAYMENT_STATUS_RESET,
  UPDATE_BOOKING_STATUS_REQUEST,
  UPDATE_BOOKING_STATUS_SUCCESS,
  UPDATE_BOOKING_STATUS_FAILURE,
  UPDATE_BOOKING_STATUS_RESET,
} from "./BookingType";

// Fetch all bookings
export const fetchBookingsRequest = (payload) => ({
  type: FETCH_BOOKINGS_REQUEST,
  payload,
});

export const fetchBookingsSuccess = (bookings) => ({
  type: FETCH_BOOKINGS_SUCCESS,
  payload: bookings,
});

export const fetchBookingsFailure = (error) => ({
  type: FETCH_BOOKINGS_FAILURE,
  payload: error,
});

// Fetch all bookings without pagination
export const fetchAllBookingsRequest = () => ({
  type: FETCH_ALL_BOOKINGS_REQUEST,
});

export const fetchAllBookingsSuccess = (bookings) => ({
  type: FETCH_ALL_BOOKINGS_SUCCESS,
  payload: bookings,
});

export const fetchAllBookingsFailure = (error) => ({
  type: FETCH_ALL_BOOKINGS_FAILURE,
  payload: error,
});

export const fetchAllBookingRequest = (payload) => ({
  type: FETCH_ALL_BOOKING_REQUEST,
  payload,
});

export const fetchAllBookingSuccess = (bookings) => ({
  type: FETCH_ALL_BOOKING_SUCCESS,
  payload: bookings,
});

export const fetchAllBookingFailure = (error) => ({
  type: FETCH_ALL_BOOKING_FAILURE,
  payload: error,
});
// Fetch a single booking
export const fetchBookingRequest = (bookingId) => ({
  type: FETCH_BOOKING_REQUEST,
  payload: bookingId,
});

export const fetchBookingSuccess = (booking) => ({
  type: FETCH_BOOKING_SUCCESS,
  payload: booking,
});

export const fetchBookingFailure = (error) => ({
  type: FETCH_BOOKING_FAILURE,
  payload: error,
});

// Add a new booking
export const addBookingRequest = (bookingData) => ({
  type: ADD_BOOKING_REQUEST,
  payload: bookingData,
});

export const addBookingSuccess = (message) => ({
  type: ADD_BOOKING_SUCCESS,
  payload: message,
});

export const addBookingFailure = (error) => ({
  type: ADD_BOOKING_FAILURE,
  payload: error,
});

// Delete a booking
export const deleteBookingRequest = (cancelDetails) => ({
  type: DELETE_BOOKING_REQUEST,
  payload: cancelDetails,
});

export const deleteBookingSuccess = (message) => ({
  type: DELETE_BOOKING_SUCCESS,
  payload: message,
});

export const deleteBookingFailure = (error) => ({
  type: DELETE_BOOKING_FAILURE,
  payload: error,
});

export const fetchServiceTypeRequest = (payload) => ({
  type: FETCH_SERVICE_TYPE_REQUEST,
  payload,
});
export const fetchServiceTypeSuccess = (payload) => ({
  type: FETCH_SERVICE_TYPE_SUCCESS,
  payload,
});
export const fetchServiceTypeFailure = (payload) => ({
  type: FETCH_SERVICE_TYPE_FAILURE,
  payload,
});
export const fetchTransitServiceTypeRequest = (payload) => ({
  type: FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
  payload,
});
export const fetchTransitServiceTypeSuccess = (payload) => ({
  type: FETCH_TRANSIT_SERVICE_TYPE_SUCCESS,
  payload,
});
export const fetchTransitServiceTypeFailure = (payload) => ({
  type: FETCH_TRANSIT_SERVICE_TYPE_FAILURE,
  payload,
});
//Reset Booking Service

export const resetBookingDetails = () => ({
  type: RESET_BOOKING_DETAILS,
});

export const fetchCustomerBookingsRequest = (payload) => ({
  type: FETCH_CUSTOMER_BOOKINGS_REQUEST,
  payload,
});

export const fetchCustomerBookingsSuccess = (data) => ({
  type: FETCH_CUSTOMER_BOOKINGS_SUCCESS,
  payload: data,
});

export const fetchCustomerBookingsFailure = (error) => ({
  type: FETCH_CUSTOMER_BOOKINGS_FAILURE,
  payload: error,
});
export const fetchComplementaryBookingsRequest = (params) => ({
  type: FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
  payload: params,
});

export const fetchComplementaryBookingsSuccess = (data) => ({
  type: FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS,
  payload: data,
});

export const fetchComplementaryBookingsFailure = (error) => ({
  type: FETCH_COMPLEMENTARY_BOOKINGS_FAILURE,
  payload: error,
});

export const fetchInstantBookingsRequest = (params) => ({
  type: FETCH_INSTANT_BOOKINGS_REQUEST,
  payload: params,
});

export const fetchInstantBookingsSuccess = (data) => ({
  type: FETCH_INSTANT_BOOKINGS_SUCCESS,
  payload: data,
});

export const fetchInstantBookingsFailure = (error) => ({
  type: FETCH_INSTANT_BOOKINGS_FAILURE,
  payload: error,
});

export const updateBookingDiscountApprovalStatusRequest = (payload) => ({
  type: UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
  payload,
});

export const updateBookingDiscountApprovalStatusSuccess = (data) => ({
  type: UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_SUCCESS,
  payload: data,
});

export const updateBookingDiscountApprovalStatusFailure = (error) => ({
  type: UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE,
  payload: error,
});

export const insertInstantBookingRequest = (payload) => ({
  type: INSERT_INSTANT_BOOKING_REQUEST,
  payload: payload,
});
export const insertInstantBookingSuccess = (payload) => ({
  type: INSERT_INSTANT_BOOKING_SUCCESS,
  payload: payload,
});
export const insertInstantBookingFailure = (payload) => ({
  type: INSERT_INSTANT_BOOKING_FAILURE,
  payload: payload,
});

export const editBookingRequest = (payload) => ({
  type: EDIT_BOOKING_REQUEST,
  payload: payload,
});
export const editBookingSuccess = (payload) => ({
  type: EDIT_BOOKING_SUCCESS,
  payload: payload,
});
export const editBookingFailure = (payload) => ({
  type: EDIT_BOOKING_FAILURE,
  payload: payload,
});
export const instantBookingTokenGeneratorRequest = () => ({
  type: INSTANT_TOKEN_GENERATOR_REQUEST,
});
export const instantBookingTokenGeneratorSuccess = (payload) => ({
  type: INSTANT_TOKEN_GENERATOR_SUCCESS,
  payload: payload,
});
export const instantBookingTokenGeneratorFailure = (payload) => ({
  type: INSTANT_TOKEN_GENERATOR_FAILURE,
  payload: payload,
});

export const getAllBookingsRequest = (payload) => ({
  type: GET_ALL_BOOKINGS_REQUEST,
  payload,
});

export const getAllBookingsSuccess = (bookings) => ({
  type: GET_ALL_BOOKINGS_SUCCESS,
  payload: bookings,
});

export const getAllBookingsFailure = (error) => ({
  type: GET_ALL_BOOKINGS_FAILURE,
  payload: error,
});

export const resendRazorpayLinkRequest = (payload) => ({
  type: RAZORPAY_RESEND_LINK_REQUEST,
  payload,
});

export const resendRazorpayLinkSuccess = (data) => ({
  type: RAZORPAY_RESEND_LINK_SUCCESS,
  payload: data,
});

export const resendRazorpayLinkFailure = (error) => ({
  type: RAZORPAY_RESEND_LINK_FAILURE,
  payload: error,
});

export const resendRazorpayLinkReset = () => ({
  type: RAZORPAY_RESEND_LINK_RESET,
});


export const updatePaymentStatusRequest = (payload) => ({
  type: UPDATE_PAYMENT_STATUS_REQUEST,
  payload,
});

export const updatePaymentStatusSuccess = (data) => ({
  type: UPDATE_PAYMENT_STATUS_SUCCESS,
  payload: data,
});

export const updatePaymentStatusFailure = (error) => ({
  type: UPDATE_PAYMENT_STATUS_FAILURE,
  payload: error,
});

export const updatePaymentStatusReset = () => ({
  type: UPDATE_PAYMENT_STATUS_RESET,
});



export const updateBookingStatusRequest = (payload) => ({
  type: UPDATE_BOOKING_STATUS_REQUEST,
  payload,
});

export const updateBookingStatusSuccess = (data) => ({
  type: UPDATE_BOOKING_STATUS_SUCCESS,
  payload: data,
});

export const updateBookingStatusFailure = (error) => ({
  type: UPDATE_BOOKING_STATUS_FAILURE,
  payload: error,
});

export const updateBookingStatusReset = () => ({
  type: UPDATE_BOOKING_STATUS_RESET,
});